import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";

class Read_record extends PureComponent {
  render() {
    return (
      <div className="row" id="read_record">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>Read Record</h2>
              <p>
                The Read Record function is a simple{" "}
                <span className="methodCodeGET fs16">GET</span> request and can
                be called straight from the browser. Like other API calls, the
                Read Record function requires a Session ID. The HTTP standard
                says a <span className="methodCodeGET fs16">GET</span> request
                cannot contain a request body. The only way to pass the Session
                ID to the API server is through a query string. Nexoid offers
                two types of Read Record functions; Read Record and Read Record
                only if updated. Read Record only if updated is charged at half
                normal data usage.
              </p>
              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="col-md-6 darkCol">
          <div className="contentDark">
            <section>
              <h2>Read Record Example</h2>
            </section>
            <section>
              <h3>Example 1:</h3>
              <p>This example will get the record with the Record ID of 454.</p>
              <p>Request:</p>
              <div className="darkCode">
                <span className="methodCodeGET">GET</span> - https://
                <span className="jsonY">example</span>.api.nexoid.com/v1/record/
                <span className="jsonY">object_type</span>/
                <span className="jsonY">454</span>?session_id=
                <span className="jsonO">
                  &#123;&#123;session_id&#125;&#125;
                </span>
              </div>
              <p>Response:</p>
              <div className="darkCode">
                <div>
                  Code: <span className="statusCode">200</span>
                </div>
                <div>
                  <br />
                </div>
                <div>Body:</div>
                <div>&#123;</div>
                <div className="i1">
                  <span className="jsonG">"id"</span>:{" "}
                  <span className="jsonY">"453"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"record"</span>: &#123;
                </div>
                <div className="i2">
                  <span className="jsonG">"text_name"</span>:{" "}
                  <span className="jsonY">"Meet Greg"</span>,
                </div>
                <div className="i2">
                  <span className="jsonG">"long_room_no"</span>:{" "}
                  <span className="jsonP">4</span>,
                </div>
                <div className="i2">
                  <span className="jsonG">"object_created_by"</span>: &#123;
                </div>
                <div className="i3">
                  <span className="jsonG">"text_first_name"</span>:{" "}
                  <span className="jsonY">"John"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"text_last_name"</span>:{" "}
                  <span className="jsonY">"Smith"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"text_username"</span>:{" "}
                  <span className="jsonY">"JOHN"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"date_created"</span>:{" "}
                  <span className="jsonY">"2016-03-08T13:04:16.069Z"</span>
                </div>
                <div className="i2">&#125;,</div>
                <div className="i2">
                  <span className="jsonG">"object_updated_by"</span>: &#123;
                </div>
                <div className="i3">
                  <span className="jsonG">"text_first_name"</span>:{" "}
                  <span className="jsonY">"John"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"text_last_name"</span>:{" "}
                  <span className="jsonY">"Smith"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"text_username"</span>:{" "}
                  <span className="jsonY">"JOHN"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"date_updated"</span>:{" "}
                  <span className="jsonY">"2016-03-08T13:04:16.069Z"</span>
                </div>
                <div className="i2">&#125;</div>
                <div className="i1">&#125;</div>
                <div>&#125;</div>
              </div>
            </section>
            <section>
              <h3>Example 2:</h3>
              <p>
                This example will get the record with the Record ID of 454 if it
                was wasn't last changed at 2016-03-08T13:04:16.069Z.
              </p>
              <p>
                In the event the record has not been changed since the time
                given the response will return the record ID and an empty record
                object.
              </p>
              <p>Request:</p>
              <div className="darkCode">
                <span className="methodCodeGET">GET</span> - https://
                <span className="jsonY">example</span>.api.nexoid.com/v1/record/
                <span className="jsonY">object_type</span>/
                <span className="jsonY">454</span>/changed/
                <span className="jsonY">2016-03-08T13:04:16.069Z</span>
                ?session_id=
                <span className="jsonO">
                  &#123;&#123;session_id&#125;&#125;
                </span>
              </div>
              <p>Response:</p>
              <div className="darkCode">
                <div>
                  Code: <span className="statusCode">200</span>
                </div>
                <div>
                  <br />
                </div>
                <div>Body:</div>
                <div>&#123;</div>
                <div className="i1">
                  <span className="jsonG">"id"</span>:{" "}
                  <span className="jsonY">"453"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"record"</span>: &#123;
                </div>
                <div className="i2">
                  <span className="jsonG">"text_name"</span>:{" "}
                  <span className="jsonY">"Meet Greg"</span>,
                </div>
                <div className="i2">
                  <span className="jsonG">"long_room_no"</span>:{" "}
                  <span className="jsonP">4</span>,
                </div>
                <div className="i2">
                  <span className="jsonG">"object_created_by"</span>: &#123;
                </div>
                <div className="i3">
                  <span className="jsonG">"text_first_name"</span>:{" "}
                  <span className="jsonY">"John"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"text_last_name"</span>:{" "}
                  <span className="jsonY">"Smith"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"text_username"</span>:{" "}
                  <span className="jsonY">"JOHN"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"date_created"</span>:{" "}
                  <span className="jsonY">"2016-03-08T13:04:16.069Z"</span>
                </div>
                <div className="i2">&#125;,</div>
                <div className="i2">
                  <span className="jsonG">"object_updated_by"</span>: &#123;
                </div>
                <div className="i3">
                  <span className="jsonG">"text_first_name"</span>:{" "}
                  <span className="jsonY">"John"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"text_last_name"</span>:{" "}
                  <span className="jsonY">"Smith"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"text_username"</span>:{" "}
                  <span className="jsonY">"JOHN"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"date_updated"</span>:{" "}
                  <span className="jsonY">"2016-03-08T13:04:16.069Z"</span>
                </div>
                <div className="i2">&#125;</div>
                <div className="i1">&#125;</div>
                <div>&#125;</div>
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  }
}

export default Read_record;



// WEBPACK FOOTER //
// ./src/components/knowlege/api/Read_record.js